








import { Component, Vue } from 'vue-property-decorator';
import GeneralSettings from './generalsettings/GeneralSettings.vue';
import Timeline from "./timeline/Timeline.vue";
import ConnectionTable from './conntable/ConnectionTable.vue';

export default {
  name: 'AppTimeline',
  components: {
    GeneralSettings,
    Timeline,
    ConnectionTable
  }
}
